<template>
    <img src="/images/svg/RSSB-x-Loop-login.svg" alt="RSSB Logo" />
</template>
